export default __webpack_public_path__ + "static/texture-yellow-dots-01-3c6ad8f4141fc739a97caa7d0d53a59f.png";